/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Knowledge_Present_4Inputs */



/**
* | output |
* | --- |
* | "checking your knowledge base" |
*
* @param {Chat_Summary_Knowledge_Present_4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_knowledge_present_4 = /** @type {((inputs?: Chat_Summary_Knowledge_Present_4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Knowledge_Present_4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("schaue in deiner Wissensdatenbank nach")
	return /** @type {LocalizedString} */ ("checking your knowledge base")
});